import { Tag } from 'antd';
import { reviewStatusLabel } from '@/features/inventorization/review-i18n';
import type { InventorizeReviewStatus } from '@/features/inventorization/domain/review/inventorize-review-fields';

const reviewStatusTagColorByStatus: Record<InventorizeReviewStatus, string> = {
  accepted: 'green',
  empty: 'red',
  manual: 'blue',
  parsed: 'green',
  unsure: 'orange',
  waived: 'default',
};

export function readInventorizeReviewStatusTagColor(status: InventorizeReviewStatus) {
  return reviewStatusTagColorByStatus[status];
}

export function ReviewStatusTag({ status }: { status: InventorizeReviewStatus }) {
  return <Tag color={readInventorizeReviewStatusTagColor(status)}>{reviewStatusLabel(status)}</Tag>;
}
